import { RootState } from '../../store/root-state';
import { SnackbarConfig } from './snackbar';

export const getSnackbarState = (state: RootState): SnackbarConfig => {
  return state.snackbar.snackbar;
};
